// @flow
import { compose, prop } from "ramda"
import type { Selector } from "common/redux/types"
import type { BasketState } from "./reducer"
import type { PendingReservation } from "./types"

const base: Selector<BasketState> = prop("basket")

export const selectItems: Selector<PendingReservation[]> = compose(
  prop("items"),
  base,
)



// WEBPACK FOOTER //
// ./src/data/basket/selectors.js